import React from "react";
import { Heading, Box, SimpleGrid, HStack } from "@chakra-ui/react";
import Products from "../components/Products";

function ProductsScreen() {
    return (
        <Box
            px={"3.5rem"}
            bg={"#f4f4f4"}
        >

            <Box 
                px={{ lg: 12, xl: 24 }}
                py={{ base: 6, md: 12, lg: 12 }}
                // pt={{ md: 10 }}
            >
                <HStack spacing={"auto"} pb={10}>
                <Heading>
                    Our Products
                </Heading>

                </HStack>
                <SimpleGrid
                    columns={{ sm: 1, md: 2, lg: 3, xl: 4 }}
                    columnGap={{ base: 4, md: 6 }}
                    rowGap={{ base: 8, md: 10 }}
                    alignContent="center"
                >
                    <Products />
                </SimpleGrid>
            </Box>
        </Box>
    )
}

export default ProductsScreen;